<div class="relative w-full h-full flex flex-col" [class.drawer-mode]="displayMode === 'drawer'">
  <!-- Toolbar -->
  <div class="flex items-center justify-between p-3 bg-white border-b border-gray-200 shadow-sm z-10">
    <h1 class="text-lg font-semibold text-gray-900">{{ captions.title }}</h1>
    
    <div class="flex items-center space-x-4">
      <!-- Selection mode toggle (only show if enabled and actions are available) -->
      <div *ngIf="enableSelectionMode && selectionActions.length > 0" class="flex items-center space-x-2">
        <span class="text-sm text-gray-600">{{ captions.selectionModeLabel }}</span>
        <button 
          (click)="toggleSelectionMode()"
          [disabled]="isGeofenceModeActive"
          [class]="isSelectionModeActive 
            ? 'bg-blue-600 border-blue-600' 
            : isGeofenceModeActive 
              ? 'bg-gray-100 border-gray-200 opacity-50 cursor-not-allowed' 
              : 'bg-gray-200 border-gray-300'"
          class="relative inline-flex h-6 w-11 items-center rounded-full border-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
          <span 
            [class]="isSelectionModeActive 
              ? 'translate-x-6 bg-white' 
              : 'translate-x-1 bg-white'"
            class="inline-block h-4 w-4 transform rounded-full shadow-sm transition-transform">
          </span>
        </button>
      </div>

      <!-- Geofence mode toggle (only show if geofence mode is enabled) -->
      <div *ngIf="enableGeofenceMode" class="flex items-center space-x-2">
        <span class="text-sm text-gray-600">{{ captions.geofenceModeLabel }}</span>
        <button 
          (click)="toggleGeofenceMode()"
          [disabled]="isSelectionModeActive"
          [class]="isGeofenceModeActive 
            ? 'bg-blue-600 border-blue-600' 
            : isSelectionModeActive 
              ? 'bg-gray-100 border-gray-200 opacity-50 cursor-not-allowed' 
              : 'bg-gray-200 border-gray-300'"
          class="relative inline-flex h-6 w-11 items-center rounded-full border-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
          <span 
            [class]="isGeofenceModeActive 
              ? 'translate-x-6 bg-white' 
              : 'translate-x-1 bg-white'"
            class="inline-block h-4 w-4 transform rounded-full shadow-sm transition-transform">
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Map container -->
  <div class="flex-1 relative">
    <div [id]="containerId" class="w-full h-full"></div>

    <!-- Dynamic drawer container (for marker details) -->
    <div #drawerContainer></div>
    
    <!-- Selection drawer container (positioned from side, below toolbar) -->
    <div #selectionDrawerContainer></div>
    
    <!-- Geofence drawer container (positioned from side, below toolbar) -->
    <div #geofenceDrawerContainer></div>
  </div>
</div>

<!-- Hidden templates for markers -->
<div class="hidden">
  <!-- Custom marker template -->
  <div #markerTemplate class="relative flex items-center justify-center transform -translate-y-2">
    <svg width="32" height="40" viewBox="0 0 32 40" class="drop-shadow-sm">
      <!-- Marker shadow (sutil para no acumular negro cuando hay pines cercanos) -->
      <ellipse cx="16" cy="37" rx="7" ry="2.5" fill="rgba(0,0,0,0.12)"/>
      <!-- Marker body -->
      <path #markerBody 
            d="M16 4 C10 4 5 9 5 15 C5 23 16 36 16 36 S27 23 27 15 C27 9 22 4 16 4 Z" 
            stroke="rgb(55 65 81)" 
            stroke-width="2" />
      <!-- Inner circle -->
      <circle cx="16" cy="15" r="6" fill="white" stroke="rgb(107 114 128)" stroke-width="1"/>
      <!-- Center dot -->
      <circle #markerDot cx="16" cy="15" r="3"/>
    </svg>
  </div>

  <!-- Popup template -->
  <div #popupTemplate class="p-3 min-w-[250px]">
    <h3 class="font-semibold text-gray-800 mb-1" #popupTitle>Marker Title</h3>
    <p class="popup-subtitle text-sm font-medium text-gray-600 mb-1">Subtitle</p>
    <p class="popup-description text-sm text-gray-600 mb-3">Description text</p>
    
    <!-- Custom properties section - will be hidden if no custom properties -->
    <div class="popup-custom-props space-y-1 mb-3 p-2 bg-gray-50 rounded border-l-2 border-blue-400" style="display: none;">
      <!-- Custom properties will be injected here -->
    </div>
    
    <div class="flex items-center justify-between pt-2 border-t border-gray-200">
      <div class="flex items-center">
        <div #popupColor class="w-3 h-3 rounded-full mr-2 border border-gray-300"></div>
        <span #popupGroupName class="text-xs text-gray-500">Group Name</span>
      </div>
      <span #popupCoords class="text-xs text-gray-400">Coordinates</span>
    </div>
  </div>

  <!-- Selection drawer template -->
  <div #selectionDrawerTemplate class="selection-drawer-panel absolute top-0 left-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 border-r border-gray-200">
    <div class="h-full flex flex-col">
      <!-- Fixed Header -->
      <div class="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50 flex-shrink-0">
        <h2 class="text-lg font-semibold text-gray-900 selection-drawer-title">{{ captions.selectedMarkersTitle }}</h2>
      </div>

      <!-- Fixed Controls Bar -->
      <div class="flex items-center justify-between p-4 border-b border-gray-200 bg-white flex-shrink-0">
        <span class="selection-count text-md font-medium text-gray-700">0 seleccionados</span>
        <div class="flex items-center gap-2">
          <button class="clear-all-selections px-3 py-1 text-sm text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition-colors duration-200">{{ captions.clearAllButton }}</button>
          <div class="relative">
            <button class="actions-dropdown-toggle p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors duration-200" title="Más acciones">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"/>
              </svg>
            </button>
            <div class="actions-dropdown absolute right-0 top-full mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-10 hidden">
              <div class="py-1">
                <!-- Action items will be dynamically populated based on selectionActions -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Scrollable Body -->
      <div class="flex-1 overflow-y-auto">
        <div class="empty-state text-center text-gray-500 py-8 px-4">
          <p>{{ captions.noMarkersSelected }}</p>
          <p class="text-sm mt-1">{{ captions.selectionInstruction }}</p>
        </div>
        <div class="marker-list space-y-1">
          <!-- Selected markers will be added here using template cloning -->
        </div>
      </div>
    </div>
  </div>

  <!-- Selection marker item template -->
  <div #selectionMarkerTemplate class="flex items-center p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer">
    <div class="marker-color w-4 h-4 rounded-full mr-3 border border-gray-300"></div>
    <div class="flex-1">
      <div class="marker-name font-medium text-gray-900">Marker Title</div>
      <div class="marker-location text-xs text-gray-400">Coordinates</div>
      <div class="marker-group text-xs text-gray-500 mt-1">Group Name</div>
    </div>
    <button class="remove-marker-btn ml-2 p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors duration-200" title="Quitar de la selección">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- Geofence drawer template -->
  <div #geofenceDrawerTemplate class="geofence-drawer-panel absolute top-0 left-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 border-r border-gray-200">
    <div class="h-full flex flex-col">
      <!-- Fixed Header -->
      <div class="p-4 border-b border-gray-200 bg-gray-50 flex-shrink- h-full flex flex-col">
        <!-- Title Section -->
        <div class="mb-4">
          <h2 class="text-lg font-semibold text-gray-900 geo-drawer-title">{{ captions.geofencesTitle }}</h2>
        </div>
        
        <!-- Content will be populated by the component -->
        <div class="geo-drawer-content flex flex-col flex-grow h-full">
          <!-- Geofence Creation Buttons (default content) -->
          <div class="creation-buttons-section pb-4 px-4 border-b">
            <div class="flex items-center justify-between">
              <span class="text-sm font-medium text-gray-700">{{ captions.addGeofenceLabel }}</span>
              <div class="flex space-x-2">
                <!-- Polygon Button -->
                <button
                  class="draw-polygon-btn p-2 bg-purple-600 border border-purple-700 rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                  [title]="captions.createPolygonTooltip">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5v16h18V3l-10.5 7.5z"/>
                  </svg>
                </button>

                <!-- Rectangle Button -->
                <button
                  class="draw-rectangle-btn p-2 bg-blue-600 border border-blue-700 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                  [title]="captions.createRectangleTooltip">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4h16v16H4z"/>
                  </svg>
                </button>

                <!-- Circle Button -->
                <button
                  class="draw-circle-btn p-2 bg-green-600 border border-green-700 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white"
                  [title]="captions.createCircleTooltip">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke-width="2"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Scrollable Content -->
          <div class="flex flex-col flex-1 pt-4  overflow-y-auto min-h-0" style="max-height: 80%">
            <!-- Enhanced Empty State -->
            <div class="no-geofences-message flex flex-col items-center justify-center py-12 px-6 text-center" style="display: none;">
              <!-- Empty state icon -->
              <div class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-6">
                <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" 
                        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
                </svg>
              </div>
              
              <!-- Empty state content -->
              <h3 class="text-lg font-medium text-gray-900 mb-2">{{ captions.noGeofencesTitle }}</h3>
              <p class="text-sm text-gray-500 mb-6 max-w-xs">{{ captions.noGeofencesSubtitle }}</p>
            </div>
            
            <!-- Geofences list container -->
            <div class="geofences-list space-y-3">
              <!-- Geofence items will be injected here -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Geofence item template -->
  <div #geofenceItemTemplate class="geofence-item p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
    <div class="flex items-center justify-between">
      <div class="flex-1">
        <div class="flex items-center space-x-2">
          <div class="geofence-color w-3 h-3 rounded-full border border-gray-300"></div>
          <span class="geofence-name text-sm font-medium text-gray-900">Geofence Name</span>
        </div>
        <div class="flex items-center mt-1 space-x-2">
          <div class="flex items-center space-x-1">
            <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
            <span class="marker-count text-xs text-gray-500">0 {{ captions.markersCountLabel }}</span>
          </div>
          <span class="geofence-type text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600">Type</span>
        </div>
      </div>
      
      <div class="flex space-x-1">
        <button class="edit-geofence-btn p-1 text-blue-600 hover:text-blue-800">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
          </svg>
        </button>
        <button class="remove-geofence-btn p-1 text-red-600 hover:text-red-800">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Geofence creation drawing mode template -->
  <div #geofenceDrawingModeTemplate class="drawing-mode-section h-full flex flex-col p-2">
    <div class="flex items-center justify-end">
      <button class="cancel-drawing-mode-btn text-gray-400 hover:text-gray-600">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    
    <div class="flex-1 flex items-center justify-center">
      <div class="text-center text-gray-600">
        <div class="drawing-icon mb-4">
          <svg class="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5v16h18V3l-10.5 7.5z"/>
          </svg>
        </div>
        <h4 class="text-lg font-medium mb-2">{{ captions.drawOnMapLabel }}</h4>
        <p class="text-sm">{{ captions.drawOnMapInstruction }}</p>
        <p class="text-xs mt-1 text-gray-500">{{ captions.cancelDrawingInstruction }}</p>
      </div>
    </div>
  </div>

  <!-- Geofence creation form template -->
  <div #geofenceCreateFormTemplate class="creation-form-section p-4">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-medium form-title">{{ captions.createGeofenceFormTitle }}</h3>
      <button class="cancel-form-btn text-gray-400 hover:text-gray-600">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <div class="space-y-4">
      <!-- Name Input -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ captions.geofenceNameLabel }}</label>
        <input
          type="text"
          class="geofence-name-input w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          [placeholder]="captions.geofenceNamePlaceholder">
      </div>

      <!-- Description Input -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ captions.geofenceDescriptionLabel }}</label>
        <textarea
          class="geofence-description-input w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 placeholder-opacity-10"
          rows="2"
          [placeholder]="captions.geofenceDescriptionPlaceholder">
        </textarea>
      </div>

      <!-- Color Picker -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ captions.geofenceColorLabel }}</label>
        <div class="flex items-center space-x-2">
          <input
            type="color"
            class="geofence-color-input w-12 h-8 border border-gray-300 rounded cursor-pointer"
            value="#3B82F6">
          <span class="geofence-color-display text-sm text-gray-600">#3B82F6</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex justify-between pt-4">
        <div>
          <button
            class="start-drawing-btn px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500">
            {{ captions.drawOnMapButton }}
          </button>
        </div>
        <div class="flex space-x-2 w-full max-w-xs ml-auto">
          <button
            class="cancel-form-btn flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500">
            {{ captions.cancelGeofenceButton }}
          </button>
          <button
            class="save-geofence-btn flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            style="display: none;">
            {{ captions.saveGeofenceButton }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
